<div class="main-wrapper">
  <div class="header-wrapper">
    <div class="navigation-container">
      <app-header></app-header>
      <router-outlet (activate)="changeOfRoutes()"></router-outlet>
      <app-custom-notifications></app-custom-notifications>
    </div>
  </div>
</div>
